import { FONT_KIND, normalizeFontName } from "./fonts";
import {
  SKIP_PERSIST_ITALIC,
  canonicalFontFamilyName,
} from "./resolveFontFamilyIdentity";

export const stylesFromParsedFont = (parsed) => {
  if (!parsed?.ok) return [];
  if (parsed.kind === FONT_KIND.VARIABLE) {
    const names = Object.values(parsed.namedInstances || {}).map(
      (instance) => instance.name
    );
    return names.length ? names : [parsed.faceName].filter(Boolean);
  }
  return [parsed.faceName || parsed.subfamily].filter(Boolean);
};

const familyKey = ({ familyName, kind }) =>
  `${normalizeFontName({ name: familyName })}::${
    kind === FONT_KIND.VARIABLE ? FONT_KIND.VARIABLE : FONT_KIND.STATIC
  }`;

const pushUnique = (list, value) => {
  if (!value || list.includes(value)) return;
  list.push(value);
};

export const groupFontUploadEntries = (entries = []) => {
  const families = [];
  const familyIndex = new Map();
  const unparsed = [];

  entries.forEach((entry) => {
    const familyName = canonicalFontFamilyName({
      name: entry?.parsed?.familyName,
    });
    if (!entry?.parsed?.ok || !familyName) {
      unparsed.push(entry);
      return;
    }
    const kind =
      entry.parsed.kind === FONT_KIND.VARIABLE
        ? FONT_KIND.VARIABLE
        : FONT_KIND.STATIC;
    const key = familyKey({ familyName, kind });
    let group = familyIndex.get(key);
    if (!group) {
      group = {
        key,
        familyName,
        kind,
        entries: [],
        styles: [],
        skipPersist: true,
      };
      familyIndex.set(key, group);
      families.push(group);
    }
    group.entries.push(entry);
    stylesFromParsedFont(entry.parsed).forEach((styleName) =>
      pushUnique(group.styles, styleName)
    );
    if (entry.parsed.skipPersist !== SKIP_PERSIST_ITALIC) {
      group.skipPersist = false;
    }
  });

  return { families, unparsed };
};
